import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import CareerFormTemplate from "./CareerFormTemplate";

const CareerFormPage = () => {
  // Wrap with a scrollable page container; no design change, just ensures full-page scroll
  return (
    <div className="min-h-screen overflow-y-auto">
      <MantineProvider>
        <Notifications position="top-right" />
        <CareerFormTemplate />
      </MantineProvider>
    </div>
  );
};

export default CareerFormPage;
